import React from 'react';

import { Paper, Chip as ChipUI, Typography } from '@material-ui/core';
import { findIndex, isFunction } from 'lodash';
import PropTypes from 'prop-types';

import * as S from './styles';

export default function Chip({ options, onDelete, onCompartiment, title }) {
  const [item, setItem] = React.useState(false);
  const [data, setData] = React.useState(options || []);

  // Remove item
  const handleDeleteItem = React.useCallback((value) => {
    const newData = [...data];

    newData.splice(
      findIndex(data, (option) => option.transponder === value),
      1
    );

    setData(newData);
    setItem(value);
    onDelete(value);
  }, []);

  // Check pending item
  const toggleOnDelete = React.useMemo(
    () => (item ? undefined : handleDeleteItem),
    [item]
  );

  return (
    <S.Wrapper>
      <Typography>{title}</Typography>

      <Paper component="ul">
        {data.map(({ transponder, compartimento }) => (
          <ChipUI
            key={transponder}
            color={compartimento === 0 ? 'default' : 'primary'}
            label={
              compartimento === 0
                ? transponder
                : `Comp. ${compartimento}: ${transponder}`
            }
            onDelete={
              isFunction(toggleOnDelete)
                ? () => {
                    toggleOnDelete(transponder);
                    onCompartiment(compartimento);
                  }
                : undefined
            }
          />
        ))}
      </Paper>
    </S.Wrapper>
  );
}

Chip.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string),
  onDelete: PropTypes.func.isRequired,
  onCompartiment: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
};

Chip.defaultProps = {
  options: [],
};
